import {createSlice} from '@reduxjs/toolkit';
import {
  getAdminOrganizationById,
  getAllOrganizations,
  getAllOrganizationsTransactions,
  getSuperAdminInfo,
  superAdminLogin,
  superAdminLogout,
  getAllOrganizationsEvents,
  getAdminStatistic,
  getPlatformFee,
  superAdminLogin2Factor,
} from './actions';
import {
  superAdminLoginOperation,
  superAdminLogoutOperation,
  pendingOperation,
  rejectedOperation,
  getSuperAdminInfoOperation,
  getAdminTransactionsOperation,
  getAllOrganizationsOperation,
  getOrganizationOperation,
  getAdminEventsOperation,
  getAdminStatisticsOperation,
  getPlatformFeeOperation,
  superAdminLogin2FactorOperation,
} from './operations';
import {ISuperAdminReducer} from '@/utils/types/superAdmin.interface';

export const initialState: ISuperAdminReducer = {
  superAdminInfo: null,
  isLoading: false,
  organizationList: null,
  organization: null,
  transactionList: null,
  eventsList: null,
  statistic: null,
  eventsByOrganization: null,
  platformFee: 1,
};

const superAdminStore = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(superAdminLogin.pending, pendingOperation);
    builder.addCase(superAdminLogin.fulfilled, superAdminLoginOperation);
    builder.addCase(superAdminLogin.rejected, rejectedOperation);

    builder.addCase(superAdminLogout.pending, pendingOperation);
    builder.addCase(superAdminLogout.fulfilled, superAdminLogoutOperation);
    builder.addCase(superAdminLogout.rejected, rejectedOperation);

    builder.addCase(getSuperAdminInfo.pending, pendingOperation);
    builder.addCase(getSuperAdminInfo.fulfilled, getSuperAdminInfoOperation);
    builder.addCase(getSuperAdminInfo.rejected, rejectedOperation);

    builder.addCase(getAllOrganizations.pending, pendingOperation);
    builder.addCase(getAllOrganizations.fulfilled, getAllOrganizationsOperation);
    builder.addCase(getAllOrganizations.rejected, rejectedOperation);

    builder.addCase(getAllOrganizationsTransactions.pending, pendingOperation);
    builder.addCase(getAllOrganizationsTransactions.fulfilled, getAdminTransactionsOperation);
    builder.addCase(getAllOrganizationsTransactions.rejected, rejectedOperation);

    builder.addCase(getAdminOrganizationById.pending, pendingOperation);
    builder.addCase(getAdminOrganizationById.fulfilled, getOrganizationOperation);
    builder.addCase(getAdminOrganizationById.rejected, rejectedOperation);

    builder.addCase(getAllOrganizationsEvents.pending, pendingOperation);
    builder.addCase(getAllOrganizationsEvents.fulfilled, getAdminEventsOperation);
    builder.addCase(getAllOrganizationsEvents.rejected, rejectedOperation);

    builder.addCase(getAdminStatistic.pending, pendingOperation);
    builder.addCase(getAdminStatistic.fulfilled, getAdminStatisticsOperation);
    builder.addCase(getAdminStatistic.rejected, rejectedOperation);

    builder.addCase(getPlatformFee.pending, pendingOperation);
    builder.addCase(getPlatformFee.fulfilled, getPlatformFeeOperation);
    builder.addCase(getPlatformFee.rejected, rejectedOperation);

    builder.addCase(superAdminLogin2Factor.pending, pendingOperation);
    builder.addCase(superAdminLogin2Factor.fulfilled, superAdminLogin2FactorOperation);
    builder.addCase(superAdminLogin2Factor.rejected, rejectedOperation);
  },
});

export default superAdminStore.reducer;
